import React, { useEffect } from "react";
import Loading from "../Loading/Loading";
import ErrorPopover from "../common/ErrorPopover/ErrorPopover";
import { useQuery } from "@apollo/client/react";
import { GetFoodPrintReport } from "./types/GetFoodPrintReport";
import GetFoodPrintReportQuery from "./GetFoodPrintReportQuery";
import { b64toBlob } from "./pdfUtils";
import { downloadHelper } from "../../utils/downloadHelper";
import queryString from "query-string";

const geLabnumber = (search: any): string => (search.labnumber ? search.labnumber : "0");

const FoodPrintReport: React.FC<any> = () => {
  const labnumber = geLabnumber(queryString.parse(location.search));

  const {
    data,
    loading,
    error: fetchError,
  } = useQuery<GetFoodPrintReport>(GetFoodPrintReportQuery, {
    variables: { labnumber: labnumber },
  });

  // PDF
  useEffect(() => {
    if (data && data.foodprintreport && data.foodprintreport.reportpdf) {
      const blobData = b64toBlob(data.foodprintreport.reportpdf, "application/pdf");
      downloadHelper(blobData, `foodprint-report-${labnumber}.pdf`);
      window.parent.postMessage("eResults2.0 Download Complete", "*");
    }
  }, [labnumber, data]);

  if (loading) {
    return <Loading />;
  }

  if (fetchError) {
    return <ErrorPopover />;
  }

  return <div></div>;
};

export default FoodPrintReport;
